import { gql, useMutation } from '@apollo/client'
import {
  INotificationPreference,
  NotificationCategory,
} from '@dtos/NotificationPreference'
import {
  INotificationPreferencesResult,
  NOTIFICATION_PREFERENCES,
} from '@services/api/graphql/queries/notificationPreferences'

export const NOTIFICATION_PREFERENCES_UPDATE = gql`
  mutation NotificationPreferencesUpdate(
    $preferences: [NotificationPreferenceInputObject!]!
    $source: String!
  ) {
    notificationPreferencesUpdate(
      input: {
        preferences: $preferences
        source: $source
        clientMutationId: "notification-preferences-update"
      }
    ) {
      preferences {
        category
        enabled
        editable
        updatedAt
      }
      errors
    }
  }
`

export type NotificationPreferenceSource = 'members_app' | 'members_web'

interface INotificationPreferencesUpdateResult {
  notificationPreferencesUpdate: {
    preferences: INotificationPreference[]
    errors: string[]
  }
}

export const useNotificationPreferencesUpdate = () => {
  const [updatePreferences, { loading }] =
    useMutation<INotificationPreferencesUpdateResult>(
      NOTIFICATION_PREFERENCES_UPDATE,
      {
        update(cache, { data }) {
          const preferences = data?.notificationPreferencesUpdate.preferences
          if (!preferences) return

          cache.writeQuery<INotificationPreferencesResult>({
            query: NOTIFICATION_PREFERENCES,
            data: { notificationPreferences: preferences },
          })
        },
      },
    )

  const handleUpdatePreference = async (
    category: NotificationCategory,
    enabled: boolean,
    source: NotificationPreferenceSource,
  ) => {
    const response = await updatePreferences({
      variables: { preferences: [{ category, enabled }], source },
    })
    return response.data?.notificationPreferencesUpdate
  }

  return { handleUpdatePreference, loading }
}
